import { useEffect, useState } from "react";
import { useShellHost } from "@/shell-handle/ShellHostProvider";
import { signOut as ampSignOut } from "aws-amplify/auth";

export const useUser = () => {
  const host = useShellHost();
  const [user, setUser] = useState(host.handle.auth.currentUser.get());

  useEffect(() => {
    setUser(host.handle.auth.currentUser.get());
    return host.handle.auth.currentUser.subscribe(setUser);
  }, [host]);

  const signOut = async () => {
    await ampSignOut();
    host.setCurrentUser(null);
    window.location.assign("/login");
  };

  return { user, signOut };
};
